import { formatCurrency } from 'components/Widget/shared/currency';
import { RESULT_LABELS } from './constants';
import { formatMonths } from './emergencyFund';
import type { EmergencyFundResult } from './types';

interface EmergencyFundCalculatorSummaryProps {
  result: EmergencyFundResult;
}

/** The two answers worth hearing; the panel below carries the inputs they came from. */
export const EmergencyFundCalculatorSummary = ({ result }: EmergencyFundCalculatorSummaryProps) => (
  <p className="text-center text-heading-sm">
    {`${RESULT_LABELS.goal} ${formatCurrency(result.goal)}.`}
    {result.monthsToGoal !== null && ` ${RESULT_LABELS.monthsToGoal} ${formatMonths(result.monthsToGoal)}.`}
  </p>
);
